import { Select, Button, Form } from 'antd';
import { ReloadOutlined } from '@ant-design/icons';
import DataSelect from '../Types/DataSelect';
import ParamsPicklist from '../Types/ParamsPicklist';
import Datas from "../Data/Data.json";
import { useAuthHeader } from '../Services/Auth/sessionAuth';
import { Crypter } from '../Functions/Security/Crypter';
import axios from 'axios';
import { useState, useEffect } from 'react';

interface SelectOption2Props {
  label?: string;
  name?: string;
  Size?: any;
  width?: number;
  widthl?: number;
  taille?: string | number;
  Option?: DataSelect[];
  Parametre?: ParamsPicklist;
  disabled?: boolean;
  DefaulValue?: any;
  icon?: any;

  // Props pour AntD Form
  value?: string;
  onChange?: (value: string) => void;
}

const SelectOption2 = (props: SelectOption2Props) => {
  const authHeader = useAuthHeader();
  const [Data, SetData] = useState<DataSelect[]>(props.Option ?? []);
  const [loading, setLoading] = useState(false);

  const loadData = async () => {
    setLoading(true);
    SetData([]);

    const data = {
      CodeAgence: props.Parametre?.CodeAgence,
      Table: props.Parametre?.Table,
      Colonne1: props.Parametre?.Colonne1,
      Colonne2: props.Parametre?.Colonne2,
      Colagence: props.Parametre?.Colagence,
      Init: props.Parametre?.Init,
      choix: props.Parametre?.Choix,
      colfiltre: props.Parametre?.colfiltre,
      valfiltre: props.Parametre?.valfiltre
    };

    const config = {
      method: 'get',
      maxBodyLength: Infinity,
      url: Datas.ApiUrl.AnySearch,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': authHeader(),
        'CypherSearch': Crypter.encrypt(JSON.stringify(data))
      }
    };

    try {
      const response = await axios(config);
      if (response.data) {
        const res = JSON.parse(Crypter.decrypt(response.data)).Value;
        if (res.StatutCode === 200 && res.Result?.Table?.length > 0) {
          const datat: DataSelect[] = res.Result.Table.map((row: any) => ({
            value: row.NUMCPT,
            label: row.NUMCPT + " -- " + row.NOMCPT
          }));
          SetData(datat);
        } else {
          SetData([]);
        }
      }
    } catch (error) {
      console.log(error);
      SetData([]);
    } finally {
      setLoading(false);
    }
  };

  // Charger les options au premier render si Option non fournie
  useEffect(() => {
    if (!props.Option) loadData();
  }, []);

  return (
    <div style={{ display: 'flex', gap: 5 }}>
      <Select
        value={props.value}           // ← forwardé par Form
        onChange={props.onChange}     // ← forwardé par Form
        loading={loading}
        showSearch
        placeholder="Sélectionner"
        optionFilterProp="label"
        style={{ width: props.taille ?? 200 }}
        suffixIcon={props.icon}
        disabled={props.disabled}
        size={props.Size}
        filterOption={(inputValue, option) =>
          option ? option.label.toUpperCase().includes(inputValue.toUpperCase()) : false
        }
        options={Data}
      />
      <Button
        icon={<ReloadOutlined />}
        loading={loading}
        onClick={loadData}
      />
    </div>
  );
};

export default SelectOption2;